import { apiClient, apiRouterProvider } from '@/common/utils';
import { ApiError } from '@/common/utils/apiClient.types';

export const createWorkspace = async (
  name: string
): Promise<{ id: string; name: string }> => {
  try {
    return await apiClient.post(apiRouterProvider.workspacesPath, { name });
  } catch (error) {
    throw (error.response.data as ApiError)?.message || error.message;
  }
};
